import React, { useState } from "react";
import ConfirmationPage from "../components/Pages/ConfirmationPage";
import AgeRestrictionModal from "../components/Modals/AgeRestrictionModal";
import { ProductId } from "../types/product";
import SessionContext from "../services/session/session";
import { ScreenCardSavingContext } from "../services/api/saving";

// Only show this route in development
const DEV_DEFAULT_PRODUCT = ProductId.TERM_LIFE_SPECIAL_OFFER;


function DevConfirmationModalTest() {
  const [saving, setSaving] = useState({ saving: false, showError: false, errorMessage: "" });
  const [showGI, setShowGI] = useState(false);
  const [showSI, setShowSI] = useState(false);
  const [showAgeRestriction, setShowAgeRestriction] = useState(false);
  const session = {
    data: {
      product: {
        id: DEV_DEFAULT_PRODUCT,
        displayName: "Term Life Special Offer",
        productKey: "",
        componentNames: [],
        showWeight: true,
        showHeight: true,
        showBasicAnnualEarnings: true,
        minAge: 18,
        maxAge: 70,
      },
      beneficiaries: [],
      applicationId: 123,
      pdmSuccess: true,
      uwReferral: { member: { shortFormCorrect: true, shownLongForm: false, shownSOHForm: false }, spouse: { shortFormCorrect: true, shownLongForm: false, shownSOHForm: false } },
      paymentFrequency: 1,
      demographic: {},
      coverages: {},
      spouse: {},
      authorization: {},
      dependents: {},
      underwriting: [],
      healthData: {},
      optIns: {},
      errors: {},
      effectiveDate: new Date(),
    },
    hasMemberFailedUw: () => false,
    hasSpouseFailedUw: () => false,
    __isMemberGi: true, // not used for this test
    setProduct: () => {},
    refresh: () => {},
  };
  const ConfModal = require("../components/ConfirmationModals/TermLifeSpecialOfferModals").default;
  return (
    <ScreenCardSavingContext.Provider value={{ saving, setSaving }}>
      <SessionContext.Provider value={session as any}>
        <div style={{ margin: 24 }}>
          <h2>Dev Modal Test</h2>
          <button style={{marginRight: 8}} onClick={() => setShowGI(true)}>Show GI Modal</button>
          <button style={{marginRight: 8}} onClick={() => setShowSI(true)}>Show SI Modal</button>
          <button onClick={() => setShowAgeRestriction(true)}>Show Age Restriction Modal</button>
          {showGI && (
            <ConfModal.TermLifeSpecialOffer.GI show={showGI} onHide={() => setShowGI(false)} />
          )}
          {showSI && (
            <ConfModal.TermLifeSpecialOffer.SI show={showSI} onHide={() => setShowSI(false)} />
          )}
          {showAgeRestriction && (
            <AgeRestrictionModal show={showAgeRestriction} onClose={() => setShowAgeRestriction(false)} />
          )}
        </div>
      </SessionContext.Provider>
    </ScreenCardSavingContext.Provider>
  );
}

export default DevConfirmationModalTest;
